import React, { useEffect, useState } from "react";
import TrackingTemplete from "../../components/TrackingTemplete";
import {
  DsersTrackingCoreV1GetTrackingPageInlineReply,
  LanguageSet,
  TrackType,
} from "../../components/TrackingTemplete/interface";

import qs from "qs";
import { message, Spin } from "antd";
const currenctColor: Record<string, string> = {
  ColorSet_Black: "#25282C",
  ColorSet_Blue: "#3D5AFE",
  ColorSet_Green: "#495242",
  ColorSet_Nil: "#25282C",
};
export function Tracking() {
  const [templeteData, setTempleteData] =
    useState<DsersTrackingCoreV1GetTrackingPageInlineReply>(
      {} as DsersTrackingCoreV1GetTrackingPageInlineReply,
    );
  const [loading, setLoading] = useState(false);
  const [shipLoading, setShipLoading] = useState(false);
  const [productLoading, setProductLoading] = useState(false);

  useEffect(() => {
    getTempleteData();

    //本地调试打开下面的注释
    // getTestTempleteData();
  }, []);

  const getTestTempleteData = async () => {
    // try {
    //   const res = await fetch(
    //     `https://bff-api-gw-test.dsers.com/dsers-tracking-bff/tracking-page/inline/get?tn=4205512492612927005455000487854047`,
    //     {
    //       method: "GET",
    //     },
    //   );
    //   const data = await res.json();
    //   setLoading(false);
    //   setTempleteData(data.data);
    //   if (data.data.storeId) {
    //     setShipLoading(true);
    //     setProductLoading(true);
    //     const shipRes = await fetch(
    //       `https://bff-api-gw-test.dsers.com/dsers-tracking-bff/tracking-page/tracking-detail?trackingNumber=4205512492612927005455000487854047&sourceType=Dsers`,
    //       {
    //         method: "GET",
    //       },
    //     );

    //     const productRes = await fetch(
    //       `https://bff-api-gw-test.dsers.com/dsers-tracking-bff/tracking-page/inline/product/get`,
    //       {
    //         method: "GET",
    //       },
    //     );

    //     shipRes.json().then((res) => {
    //       if (res.data) {
    //         data.data.tracking = res.data;
    //       } else {
    //         data.data.tracking = {};
    //       }
    //       setTempleteData(data.data);
    //       setShipLoading(false);
    //     });

    //     productRes.json().then((res) => {
    //       if (res.data) {
    //         data.data.productDetails = res.data;
    //       } else {
    //         data.data.productDetails = [];
    //       }
    //       setTempleteData(data.data);
    //       setProductLoading(false);
    //     });
    //   }
    // } catch (error) {
    //   setLoading(false);
    //   setShipLoading(false);
    //   setProductLoading(false);
    // }
    setTempleteData({
      userId: "1660556890438549504",
      storeId: "1673868268389711872",
      pageName: "testtmallorder1",
      storeName: "testtmallorder1",
      logo: "https://dsers-dev-public.oss-cn-zhangjiakou.aliyuncs.com/uploadimage/5863c061-b998-4c88-b83c-4d79f40eaa9a851012.png",
      pageInfo: "This is a test tmall store!",
      logisticSet: {
        hideCountryName: true,
        hideShippingCompany: true,
      },
      languageSet: undefined,
      bestSellerSet: "open",
      status: "InUse",
      productDetails: [
        {
          productId: "10439921664278",
          productTitle:
            "Il rinascimentale donne ritratto poster vintage vittoriano femminile tela pittura moda arte della parete soggiorno decorazioni per la casa Mura",
          productImage:
            "https://cdn.shopify.com/s/files/1/0782/7983/5926/files/Sf3771e04755141d99598a3b6e11a012ci.webp?v=1773650584",
        },
        {
          productId: "10396433416470",
          productTitle:
            "Accessori da gioco tappetino per Mouse in feltro di lana tappetino per scrittura di grandi dimensioni tappetino per Mouse per tastiera protezione antiscivolo per scrivania per Computer da ufficio a casa",
          productImage:
            "https://cdn.shopify.com/s/files/1/0782/7983/5926/files/Sb09a9f70377346179721a455225d09b1K_f3ac8aed-fabe-4923-98df-ef871178b2cd.webp?v=1769653692",
        },
        {
          productId: "10396432400662",
          productTitle:
            "Accessori da gioco tappetino per Mouse in feltro di lana tappetino per scrittura di grandi dimensioni tappetino per Mouse per tastiera protezione antiscivolo per scrivania per Computer da ufficio a casa",
          productImage:
            "https://cdn.shopify.com/s/files/1/0782/7983/5926/files/Sb09a9f70377346179721a455225d09b1K_140069ac-66e7-4671-97b7-aed9330b4db6.webp?v=1769653209",
        },
        {
          productId: "1039643240061162",
          productTitle:
            "Accessori da gioco tappetino per Mouse in feltro di lana tappetino per scrittura di grandi dimensioni tappetino per Mouse per tastiera protezione antiscivolo per scrivania per Computer da ufficio a casa",
          productImage:
            "https://cdn.shopify.com/s/files/1/0782/7983/5926/files/Sb09a9f70377346179721a455225d09b1K_140069ac-66e7-4671-97b7-aed9330b4db6.webp?v=1769653209",
        },
      ],
      isErrorEmail: true,
      tracking: undefined,
      customerSupportEmail: "",
      color: "",
    });
  };

  const getTempleteData = async () => {
    setLoading(true);
    const query = qs.parse(window.location.search.slice(1));

    const pathnameSegments = window.location.pathname
      .split("/")
      .filter((segment) => segment);

    const firstTwoSegments = pathnameSegments.slice(0, 2).join("/");

    const { hostname } = window.location;
    try {
      const res = await fetch(
        `https://${hostname}/${firstTwoSegments}/api/dsers-tracking-bff/tracking-page/inline/get?tn=${query?.tn || ""}`,
        {
          method: "GET",
        },
      );

      const data = await res.json();
      const isErrorEmail = Object.prototype.hasOwnProperty.call(
        data.data || {},
        "isErrorEmail",
      )
        ? data.data.isErrorEmail
        : true;
      setLoading(false);
      setTempleteData(data.data);
      if (data?.data?.storeId) {
        setShipLoading(true);
        setProductLoading(true);
        const shipRes = await fetch(
          `https://${hostname}/${firstTwoSegments}/api/dsers-tracking-bff/tracking-page/tracking-detail?trackingNumber=${
            query?.tn || ""
          }&sourceType=Dsers`,
          {
            method: "GET",
          },
        );
        shipRes.json().then((res) => {
          if (res.data) {
            data.data.tracking = res.data;
          } else {
            data.data.tracking = {};
          }
          // setTempleteData({
          //   ...data.data,
          //   color: currenctColor?.[data.data?.color ?? "ColorSet_Nil"],
          //   isErrorEmail,
          // });
          setTempleteData(data.data);
          setShipLoading(false);
        });
        const productRes = await fetch(
          `https://${hostname}/${firstTwoSegments}/api/dsers-tracking-bff/tracking-page/inline/product/get`,
          {
            method: "GET",
          },
        );

        productRes.json().then((res) => {
          if (res.data) {
            data.data.productDetails = res.data;
          } else {
            data.data.productDetails = [];
          }
          setTempleteData(data.data);
          setProductLoading(false);
        });
      } else {
        if (data.code && data.message) {
          message.error(data.message);
        }
        if (!data.data && !data.code) {
          message.error("Failed to obtain logistics information");
        }
      }
      setLoading(false);
      setTempleteData(data.data);
      console.log(data, "请求模板信息");
    } catch (error) {
      setLoading(false);
      setShipLoading(false);
      setProductLoading(false);
      message.error("Failed to obtain logistics information");
    }
  };

  return (
    <div style={{ maxWidth: "803px", margin: "64px auto" }}>
      {loading ? (
        <Spin spinning={loading}>
          <div style={{ height: "100vh", width: "100vw" }}></div>
        </Spin>
      ) : (
        <TrackingTemplete
          from="tracking"
          renderData={templeteData}
          loading={loading}
          shipLoading={shipLoading}
          productLoading={productLoading}
          changeBackgroundColor
        />
      )}
    </div>
  );
}
